import React, { useEffect } from "react";
// import prop
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import { Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import axios from "axios";
import {
  API_BASE_URL,
  IMAGE_URL_BUSINESS,
  IMAGE_URL_UPLOAD,
} from "@/config/serverApiConfig";
import Spinner from "react-bootstrap/Spinner";
import country_list from '../all-countries-and-cities-json'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const UpdateBusiness = (props) => {
  const [id, setId] = useState();

  

  const [show, setShow] = useState(false);
  const [submitSuccess, setsubmitSuccess] = useState(false);

  const [submitLoader, setSubmitLoader] = useState(false);
  const loaderClose = () => setSubmitLoader(false);

  const submitSuccessClose = () => setsubmitSuccess(false);

  const [businessCategory, setBusinessCategory] = useState([]);
  const [subCategory, setsubCategory] = useState([]);

  let [companyName, setCompanyName] = useState("");
  // get name from prop and set it companyName

  const [nameOfPoc, setnameOfPoc] = useState("");
  const [emailOfPoc, setemailOfPoc] = useState("");
  const [mobileOfPoc, setmobileOfPoc] = useState("");
  const [businessWebsite, setBusinessWebsite] = useState("");
  const [businessPhone, setBusinessPhone] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [businessIntro, setbusinessIntro] = useState("");
  const [businessProfile, setBusinessProfile] = useState("");
  const [businessProfileName, setBusinessProfileName] = useState("");
  const [businessCategoryError, setBusinessCategoryError] = useState("");
  const [subCategoryError, setsubCategoryError] = useState("");
  const [companyNameError, setCompanyNameError] = useState("");
  const [companyNameIsEmptyError, setCompanyNameIsEmptyError] = useState("");

  let [mobileNoLengthOne, setMobileNoLengthOne] = useState(false);
  let [mobileNoLengthTwo, setMobileNoLengthTwo] = useState(false);

  const [nameOfPocError, setnameOfPocError] = useState("");
  const [nameOfPocIsEmptyError, setnameOfPocIsEmptyError] = useState("");
  const [emailOfPocError, setemailOfPocError] = useState("");
  const [emailOfPocIsEmptyError, setemailOfPocIsEmptyError] = useState("");

  const [mobileOfPocError, setmobileOfPocError] = useState("");
  const [mobileOfPocIsEmptyError, setmobileOfPocIsEmptyError] = useState("");
  const [businessWebsiteError, setBusinessWebsiteError] = useState("");
  const [businessWebsiteIsEmptyError, setBusinessWebsiteIsEmptyError] =
    useState("");

  const [businessPhoneError, setBusinessPhoneError] = useState("");
  const [businessPhoneIsEmptyError, setBusinessPhoneIsEmptyError] =
    useState("");
  const [countryError, setCountryError] = useState("");

  const [cityError, setCityError] = useState("");

  // const businessCategoryErr = useState(false);
  const businessCategoryIsEmptyErr = useState(false);

  const [businessProfileIsEmptyErr, setBusinessProfileIsEmptyError] =
    useState(false);
  const [businessProfileError, setBusinessProfileError] = useState("");

  // const companyNameErr = useState(false);
  // const companyNameIsEmptyErr = useState(false);

  // const nameOfPocErr = useState(false);
  // const nameOfPocIsEmptyErr = useState(false);

  // const emailOfPocErr = useState(false);
  // const emailOfPocIsEmptyErr = useState(false);

  // const mobileOfPocErr = useState(false);
  // const mobileOfPocIsEmptyErr = useState(false);

  // const businessWebsiteErr = useState(false);
  // const businessWebsiteIsEmptyErr = useState(false);

  // const businessPhoneErr = useState(false);
  // const businessPhoneIsEmptyErr = useState(false);

  // const countryErr = useState(false);
  // const countryIsEmptyErr = useState(false);

  // const cityErr = useState(false);
  // const cityIsEmptyErr = useState(false);

  // getting the categories

  let [category, setCategory] = useState([]);

  useEffect(() => {
    axios(`${API_BASE_URL}category/getCategory`)
      .then((res) => {
        setCategory(res.data.data);
      })
      .catch((err) => {});
  }, []);

  const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );
  let [categoryTwoData, setCategoryTwoData] = useState([]);

  function businessCategoryHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setBusinessCategoryError(true);
    } else {
      setBusinessCategoryError(false);
      setBusinessCategory(item);
    }
    setBusinessCategory(item);
  }

  function subCategoryHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setsubCategoryError(true);
    } else {
      setsubCategoryError(false);
    }
    setsubCategory(item);
  }

  function companyNameHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setCompanyNameIsEmptyError(true);
      setCompanyNameError(false);
    } else if (item.length < 3) {
      setCompanyNameIsEmptyError(false);
      setCompanyNameError(true);
    } else {
      setCompanyNameError(false);
      setCompanyNameIsEmptyError(false);
    }
    setCompanyName(item);
  }

  function nameOfPocHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setnameOfPocIsEmptyError(true);
      setnameOfPocError(false);
    } else if (item.length < 3) {
      setnameOfPocIsEmptyError(false);
      setnameOfPocError(true);
    } else {
      setnameOfPocError(false);
      setnameOfPocIsEmptyError(false);
    }
    setnameOfPoc(item);
  }

  function emailOfPocHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setemailOfPocIsEmptyError(true);
      setemailOfPocError(false);
    } else if (!validEmailRegex.test(item)) {
      setemailOfPocError(true);
      setemailOfPocIsEmptyError(false);
    } else {
      setemailOfPocError(false);
      setemailOfPocIsEmptyError(false);
    }
    setemailOfPoc(item);
  }

  const mobileOfPocHandler = (mobileOfPoc) => {
    let item = mobileOfPoc;
    if (item === "") {
      setmobileOfPocIsEmptyError(true);
      setmobileOfPocError(false);
    } else {
      setmobileOfPocError(false);
      setmobileOfPocIsEmptyError(false);
    }
    setmobileOfPoc(item);
  };

  function businessWebsiteHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setBusinessWebsiteIsEmptyError(true);
      setBusinessWebsiteError(false);
    } else {
      setBusinessWebsiteError(false);
      setBusinessWebsiteIsEmptyError(false);
    }
    setBusinessWebsite(item);
  }

  const businessPhoneHandler = (businessPhone) => {
    let item = businessPhone;
    if (item === "") {
      setBusinessPhoneIsEmptyError(true);
      setBusinessPhoneError(false);
    } else {
      setBusinessPhoneError(false);
      setBusinessPhoneIsEmptyError(false);
    }
    setBusinessPhone(item);
  };

  function countryHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setCountryError(false);
    } else {
      setCountryError(false);
    }
    setCountry(item);
  }

  function cityHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setCityError(false);
    } else {
      setCityError(false);
    }
    setCity(item);
  }

  function businessIntroHandler(e) {
    let item = e.target.value;
    setbusinessIntro(item);
  }
  let [imageOne, setImageOne] = useState(null);
  let [imageTwo, setImageTwo] = useState(null);
  let [imageThree, setImageThree] = useState(null);
  let [imageFour, setImageFour] = useState(null);
  let [imageFive, setImageFive] = useState(null);
  function imageOneHandler(e) {
    let items = e.target.value;
    if (items.length > 1) {
      setImageOne(e.target.files[0]);
      setImageTwo(e.target.files[1]);
      setImageThree(e.target.files[2]);
      setImageFour(e.target.files[3]);
      setImageFive(e.target.files[4]);
      setImageOneError(false);
    } else {
      setImageOne(items[0]);
      setImageOneError(false);
    }
  }

  function businessProfileHandler(e) {
    let item = e.target.value;

    setBusinessProfileName(e.target.files[0].name);
    setBusinessProfile(e.target.files[0]);
  }

  let [countriesData, setcountriesData] = useState([]);
  let [cityData, setcityData] = useState([]);

  useEffect(() => {
    const country_keys = Object.keys(country_list);

    let countriesListData = country_keys.map((country_item, index) => {
      return (
        <option key={index} value={country_item}>
          {country_item}
        </option>
      );
    });
    setcountriesData(countriesListData);
  }, []);

  const countryChange = (e) => {
    let country_name = e.target.value;
    if (country_name === "") {
      setCountryError(true);
    } else {
      setCountryError(false);
    }

    setCountry(e.target.value);

    let citiesList_data = country_list[country_name].map((item, i) => {
      return (
        <option key={i} value={item}>
          {item}
        </option>
      );
    }, this);
    setCountry(e.target.value);
    setcityData(citiesList_data);
    // formData.append("country", country);
  };

  let [imageOneError, setImageOneError] = useState(false);

  let [imageOnePreview, setImageOnePreview] = useState(null);
  let [imageTwoPreview, setImageTwoPreview] = useState(null);
  let [imageThreePreview, setImageThreePreview] = useState(null);
  let [imageFourPreview, setImageFourPreview] = useState(null);
  let [imageFivePreview, setImageFivePreview] = useState(null);
  let [businessProfilePreview, setBusinessProfilePreview] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();

    if (
      businessCategory.length < 1 &&
      subCategory.length < 1 &&
      companyName.length < 1 &&
      nameOfPoc.length < 1 &&
      emailOfPoc.length < 1 &&
      mobileOfPoc.length < 1 &&
      businessWebsite.length < 1 &&
      businessPhone.length < 1 &&
      country.length < 1 &&
      city.length < 1
    ) {
      setBusinessCategoryError(true);
      setsubCategoryError(true);
      setCompanyNameIsEmptyError(true);
      setnameOfPocIsEmptyError(true);
      setemailOfPocIsEmptyError(true);
      setmobileOfPocIsEmptyError(true);
      setBusinessWebsiteIsEmptyError(true);
      setBusinessPhoneIsEmptyError(true);
      setCountryError(true);
      setCityError(true);
    }
    if (businessCategory.length < 1) {
      setBusinessCategoryError(true);
    }
    if (subCategory.length < 1) {
      setsubCategoryError(true);
    }
    if (companyName.length < 3) {
      setCompanyNameError(true);
      setCompanyNameIsEmptyError(false);
    }
    if (nameOfPoc.length < 3) {
      setnameOfPocError(true);
      setnameOfPocIsEmptyError(false);
    }
    if (emailOfPoc.length < 1) {
      setemailOfPocIsEmptyError(true);
      setemailOfPocError(false);
    } else if (!validEmailRegex.test(emailOfPoc)) {
      setemailOfPocError(true);
      setemailOfPocIsEmptyError(false);
    }
    if (mobileOfPoc === "" || mobileOfPoc.length < 5) {
      setmobileOfPocIsEmptyError(true);
    }
    if (
      businessPhone.length === "" ||
      businessPhone.length < 5 
    ) {
      setBusinessPhoneIsEmptyError(true);
    }
    if (country.length < 1) {
      setCountryError(true);
    }
    if (city.length < 1) {
      setCityError(true);
    }
     else {
      let formData = new FormData();

      formData.append("id", id);
      formData.append("category_id", businessCategory);
      formData.append("subcategory_id", subCategory);
      formData.append("companyName", companyName);
      formData.append("nameOfPoc", nameOfPoc);
      formData.append("emailOfPoc", emailOfPoc);
      formData.append("mobileOfPoc", mobileOfPoc);
      formData.append("businessWebsite", businessWebsite);
      formData.append("businessPhone", businessPhone);
      formData.append("country", country);
      formData.append("city", city);
      formData.append("businessIntro", businessIntro);
      formData.append("businessProfile", businessProfile);
      formData.append("imageOne", imageOne);
      formData.append("imageTwo", imageTwo);
      formData.append("imageThree", imageThree);
      formData.append("imageFour", imageFour);
      formData.append("imageFive", imageFive);

      const token = localStorage.getItem("token");
      let config = {
        headers: {
          "x-access-token": `${token}`,
        },
      };

      axios
        .post(
          `${API_BASE_URL}business-listing/update`,

          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "x-access-token": `${token}`,
            },
          }
        )
        .then((res) => {
          setSubmitLoader(true);
          if (res.status === 200) {
            setShow(false);
            setsubmitSuccess(true);

            setBusinessCategory("");
            setsubCategory("");
            setCompanyName("");
            setnameOfPoc("");
            setemailOfPoc("");
            setmobileOfPoc("");
            setBusinessWebsite("");
            setBusinessPhone("");
            setCountry("");
            setCity("");
            setBusinessProfile("");
          }
        })
        .catch((error) => {});
    }
  }
  let [catname, setcatname] = useState("");
  let [subCatname, setSubCatname] = useState("");
  //let [subCategory, setsubCategory] = useState("");
 

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    
    setId(props.id);
    setBusinessCategory(props.category_id);
    setcatname(props.category_name);
    setSubCatname(props.subCategory_name ? props.subCategory_name : "");
    setsubCategory(props.subCategory_id ? props.subCategory_id : "");
    setCompanyName(props.name);
    setnameOfPoc(props.nameOfPoc);
    setemailOfPoc(props.emailOfPoc);
    setmobileOfPoc(props.mobileOfPoc);
    setBusinessWebsite(props.businessWebsite);
    setBusinessPhone(props.businessPhone);
    setCountry(props.country);
    setCity(props.city);
    setBusinessProfilePreview(props.businessProfile);
    
    console.log(props.images[0]);
    setbusinessIntro(props.description);

    setImageOnePreview(IMAGE_URL_BUSINESS + props.images[0]);
    imageOnePreview == `${IMAGE_URL_BUSINESS}null` ? setImageOnePreview(`${IMAGE_URL_BUSINESS}undefined`) : "";
    
    setImageTwoPreview(IMAGE_URL_BUSINESS + props.images[1]);
    imageTwoPreview == `${IMAGE_URL_BUSINESS}null` ? setImageTwoPreview(`${IMAGE_URL_BUSINESS}undefined`) : "";
    setImageThreePreview(IMAGE_URL_BUSINESS + props.images[2]);
    imageThreePreview == `${IMAGE_URL_BUSINESS}null` ? setImageThreePreview(`${IMAGE_URL_BUSINESS}undefined`) : "";
    setImageFourPreview(IMAGE_URL_BUSINESS + props.images[3]);
    imageFourPreview == `${IMAGE_URL_BUSINESS}null` ? setImageFourPreview(`${IMAGE_URL_BUSINESS}undefined`) : "";
    setImageFivePreview(IMAGE_URL_BUSINESS + props.images[4]);
    imageFivePreview == `${IMAGE_URL_BUSINESS}null` ? setImageFivePreview(`${IMAGE_URL_BUSINESS}undefined`) : "";
    
   
    
  }

  return (
    <>
      <Button
        onClick={handleShow}
        style={{
          backgroundColor: "#9F7854",
          border: "none",
          marginLeft: "20px",
        }}
      >
        Update Business
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        className="Requestalisting-popup dash_popup_same"
      >
        <Modal.Header closeButton className="p-0">
          <Modal.Title className="d-flex align-content-center">
            <svg
              width="52"
              height="53"
              viewBox="0 0 52 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g
                clipPath="url(#clip0_113_570)"
                filter="url(#filter0_d_113_570)"
              >
                <path
                  d="M23.0802 45.0014C22.4454 44.6879 22.1618 44.1902 22.1067 43.4506C21.822 39.6129 21.496 35.7776 21.1884 31.9458C21.1815 31.8613 21.1666 31.7768 21.1493 31.6465H18.5676C17.4495 31.6465 16.9834 31.1663 16.9834 30.0159C16.9834 27.4966 16.9834 24.9784 16.9834 22.4591C16.9797 20.317 17.7059 18.2404 19.037 16.5865C20.3682 14.9325 22.2212 13.8044 24.2775 13.3962C24.4026 13.3704 24.5312 13.3645 24.716 13.341V13.8306C24.716 16.6559 24.716 19.482 24.716 22.3088C24.716 23.3654 25.6413 24.0299 26.5218 23.6155C27.0762 23.3548 27.2955 22.8794 27.2943 22.2654C27.289 19.4683 27.289 16.6711 27.2943 13.874V13.26C28.0554 13.4948 28.7775 13.6545 29.4514 13.9339C31.0912 14.6174 32.4959 15.7833 33.4874 17.2838C34.4789 18.7843 35.0127 20.5519 35.0212 22.3628C35.0362 24.9702 35.0212 27.5764 35.0212 30.1826C35.0212 31.0947 34.4955 31.6324 33.6104 31.6371C32.6978 31.6371 31.7863 31.6371 30.8484 31.6371C30.7497 32.8322 30.6521 33.985 30.5591 35.1308C30.3295 38.0046 30.098 40.8785 29.8646 43.7523C29.8153 44.3815 29.4215 44.729 28.921 44.9967L23.0802 45.0014Z"
                  fill="#9F7854"
                />
                <path
                  d="M37.3445 45.0008C36.7074 44.6897 36.4262 44.179 36.363 43.4512C36.0933 40.42 35.7718 37.3936 35.4871 34.3636C35.492 34.2799 35.5152 34.1984 35.5549 34.1251C35.5946 34.0517 35.6499 33.9884 35.7167 33.9398C37.0036 33.1263 37.6774 31.9617 37.682 30.4179C37.6912 27.8259 37.682 25.2349 37.682 22.6428C37.682 20.7176 37.2091 18.912 36.3045 17.1112C36.8325 16.8764 37.3376 16.6111 37.8634 16.4256C38.3892 16.2401 38.9322 16.138 39.5681 15.9724C38.0046 15.666 36.7889 14.9241 35.9555 13.6187C35.5446 12.9978 35.2716 12.2925 35.1558 11.5522C35.04 10.8119 35.0841 10.0547 35.2851 9.33373C35.9073 6.92948 38.2124 5.27186 40.6633 5.46556C43.1486 5.66161 45.1747 7.72424 45.3986 10.2788C45.5777 12.3285 44.4665 15.2223 40.9216 15.9936C41.2751 16.0617 41.5208 16.111 41.7653 16.1568C43.335 16.4742 44.7695 17.2825 45.8706 18.4699C46.9716 19.6572 47.6847 21.1651 47.9115 22.7849C47.9329 22.897 47.9602 23.0079 47.993 23.1171V30.85C47.4523 32.1413 46.2986 31.7457 45.2964 31.8314C45.2218 32.5628 45.1472 33.2718 45.0772 33.9821C44.7684 37.1236 44.4446 40.2651 44.1657 43.4101C44.1003 44.1509 43.8443 44.6862 43.1807 45.0008H37.3445Z"
                  fill="#101D42"
                />
                <path
                  d="M8.81566 45.0014C8.14984 44.6879 7.89728 44.1491 7.82955 43.4072C7.55175 40.2739 7.22803 37.1429 6.92038 34.0155C6.85035 33.3029 6.77803 32.5915 6.69997 31.8202C6.25915 31.8202 5.83671 31.8202 5.41311 31.8202C4.52804 31.812 4.00572 31.2755 4.00457 30.3634C4.00457 28.2103 3.99539 26.0573 4.00457 23.9066C4.0049 21.9913 4.68585 20.1414 5.92064 18.7014C7.15543 17.2613 8.85989 16.3292 10.7167 16.0787C10.8036 16.0648 10.8868 16.0328 10.9612 15.9848C9.52968 15.6795 8.35302 14.9728 7.51731 13.7449C7.10944 13.1665 6.8243 12.5073 6.68018 11.8097C6.53606 11.112 6.53617 10.3912 6.68046 9.69355C6.93118 8.44041 7.61666 7.32229 8.61041 6.54553C9.60415 5.76878 10.8391 5.38582 12.0873 5.46732C14.5749 5.61876 16.6493 7.69783 16.8754 10.2805C17.0763 12.5533 15.7344 15.3215 12.4455 15.9836C13.0436 16.1409 13.5934 16.2501 14.1204 16.432C14.6473 16.614 15.1386 16.8688 15.6368 17.0859C15.3429 17.8772 15.0525 18.5886 14.8126 19.3165C14.4677 20.4046 14.2994 21.5431 14.3144 22.6869V30.3763C14.3144 31.9447 14.971 33.1362 16.2877 33.9334C16.3769 33.9726 16.4498 34.0427 16.4936 34.1313C16.5375 34.2199 16.5495 34.3214 16.5276 34.4182C16.2177 37.4611 15.9031 40.504 15.6288 43.5504C15.5645 44.2606 15.2534 44.7138 14.6576 45.0131L8.81566 45.0014Z"
                  fill="#101D42"
                />
                <path
                  d="M26.0059 6.10352e-05C27.7142 0.00471895 29.3512 0.701531 30.5583 1.9379C31.7653 3.17427 32.4441 4.84942 32.4459 6.59651C32.4413 8.34349 31.7601 10.0175 30.5514 11.252C29.3427 12.4866 27.705 13.1811 25.9967 13.1836C24.2884 13.1786 22.6516 12.4817 21.4446 11.2454C20.2376 10.0091 19.5588 8.33411 19.5566 6.58712C19.5609 4.84003 20.242 3.16587 21.4508 1.93126C22.6595 0.696656 24.2975 0.00222978 26.0059 6.10352e-05V6.10352e-05Z"
                  fill="#9F7854"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_113_570"
                  x="0"
                  y="0"
                  width="52"
                  height="53"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_113_570"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_113_570"
                    result="shape"
                  />
                </filter>
                <clipPath id="clip0_113_570">
                  <rect
                    width="44"
                    height="45"
                    fill="white"
                    transform="translate(4)"
                  />
                </clipPath>
              </defs>
            </svg>
            <h4 className="h2_medum mb-0 ps-2">
              Update{" "}
              <span className="color-9F7854 user-name fw-bold">
                {" "}
                a business
              </span>
            </h4>
          </Modal.Title>
        </Modal.Header>
        <p>
          Please fill in the below form to the best of your knowledge. We will
          verify the business information, and you will receive a notification
          as soon as an action has been taken by the admin.{" "}
        </p>

        <Modal.Body className="p-0 pt-3">
          <Row>
            <Col lg={6} className="mb-4">
              <Form.Label>
                Business Category <span className="req">*</span>
              </Form.Label>
              <Form.Select
                defaultValue={"Select"}
                type="text"
                className="border-0 border-bottom bg-transparent"
                onChange={businessCategoryHandler}
                required
              >
                {catname ? catname : <option>Select</option>}
                {category
                  .filter((cat) => cat.isParent === true)
                  .map((value, index) => {
                    return (
                      <option value={value._id} key={index}>
                        {value.name}
                      </option>
                    );
                  })}
              </Form.Select>
              {businessCategoryError ? (
                <span className="error-msg">Category required</span>
              ) : (
                ""
              )}
            </Col>
            <Col lg={6} className="mb-4">
              <Form.Label>
                Sub Categories <span className="req">*</span>
              </Form.Label>
              <Form.Select
                onChange={subCategoryHandler}
                type="text"
                className="border-0 border-bottom bg-transparent"
                defaultValue="Choose..."
              >
                {subCatname ? subCatname : <option>Select</option>}
                {category
                  .filter((sub) => sub.parent_id === businessCategory)
                  .map((value, index) => {
                    return (
                      <option
                        placeholder="Select"
                        value={value._id}
                        key={index}
                      >
                        {value.name}
                      </option>
                    );
                  })}
              </Form.Select>
              {subCategoryError ? (
                <span className="error-msg">Category required</span>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mb-4">
              <Form.Label>
                Company Name <span className="req">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                className="border-0 border-bottom bg-transparent"
                onChange={companyNameHandler}
                value={companyName}
                required
              />
              {companyNameError ? (
                <span className="error-msg">Invalid Company Name</span>
              ) : (
                ""
              )}
              {companyNameIsEmptyError ? (
                <span className="error-msg">Company Name is required</span>
              ) : (
                ""
              )}
            </Col>
            <Col lg={6} className="mb-4">
              <Form.Label>
                Name of PoC <span className="req">*</span>
              </Form.Label>
              <Form.Control
                className="border-0 border-bottom bg-transparent"
                onChange={nameOfPocHandler}
                value={nameOfPoc}
                required
              />
              {nameOfPocError ? (
                <span className="error-msg">Invalid Name of PoC</span>
              ) : (
                ""
              )}
              {nameOfPocIsEmptyError ? (
                <span className="error-msg">Name of PoC is required</span>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mb-4">
              <Form.Label>
                Email of POC <span className="req">*</span>
              </Form.Label>
              <Form.Control
                className="border-0 border-bottom bg-transparent"
                onChange={emailOfPocHandler}
                value={emailOfPoc}
                required
              />
              {emailOfPocError ? (
                <span className="error-msg">Invalid Email of POC</span>
              ) : (
                ""
              )}
              {emailOfPocIsEmptyError ? (
                <span className="error-msg">Email of PoC is required</span>
              ) : (
                ""
              )}
            </Col>
            <Col lg={6} className="mb-4">
              <Form.Label>
                Mobile of PoC <span className="req">*</span>
              </Form.Label>
              <PhoneInput
                inputClass="form-control border-0 border-bottom bg-transparent"
                id="phone"
                country={"pk"}
                rules={{ required: true }}
                name="phone"
                value={mobileOfPoc}
                placeholder={false.toString()}
                onChange={(value, country, e) => {
                  setmobileOfPocIsEmptyError(false);
                  setMobileNoLengthOne(country.format?.split(".").length - 1);
                  setmobileOfPoc(value);
                }}
                onBlur={(e, country) => {
                  let _length = country.format?.split(".").length - 1;
                  if (mobileOfPoc.length !== _length) {
                    setmobileOfPocIsEmptyError(true);
                    autoFocus: true;
                  } else {
                    setmobileOfPocIsEmptyError(false);
                  }
                }}
              />
              {mobileOfPocError ? (
                <span className="error-msg">Invalid Mobile of PoC</span>
              ) : (
                ""
              )}
              {mobileOfPocIsEmptyError ? (
                <span className="error-msg">Mobile of PoC is required</span>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mb-4">
              <Form.Label>
                Business Website <span className="req"></span>
              </Form.Label>
              <Form.Control
                className="border-0 border-bottom bg-transparent"
                onChange={businessWebsiteHandler}
                value={businessWebsite}
                required
              />
              {businessWebsiteError ? (
                <span className="error-msg">Invalid Business Website</span>
              ) : (
                ""
              )}
              {businessWebsiteIsEmptyError ? (
                <span className="error-msg">Business Website is required</span>
              ) : (
                ""
              )}
            </Col>
            <Col lg={6} className="mb-4">
              <Form.Label>
                Business Phone <span className="req">*</span>
              </Form.Label>
              <PhoneInput
                inputClass="form-control border-0 border-bottom bg-transparent"
                id="phone"
                country={"pk"}
                rules={{ required: true }}
                name="phone"
                value={businessPhone}
                placeholder={false.toString()}
                onChange={(value, country, e) => {
                  setBusinessPhoneIsEmptyError(false);
                  setMobileNoLengthTwo(country.format?.split(".").length - 1);
                  setBusinessPhone(value);
                }}
                onBlur={(e, country) => {
                  let _length = country.format?.split(".").length - 1;
                  if (businessPhone.length !== _length) {
                    setBusinessPhoneIsEmptyError(true);
                    autoFocus: true;
                  } else {
                    setBusinessPhoneIsEmptyError(false);
                  }
                }}
              />
              {businessPhoneError ? (
                <span className="error-msg">Invalid Business Phone</span>
              ) : (
                ""
              )}
              {businessPhoneIsEmptyError ? (
                <span className="error-msg">Business Phone is required</span>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mb-4">
              <Form.Label>
                Country <span className="req">*</span>
              </Form.Label>
              <select
                id="inputCountry"
                className="form-control border-0 border-bottom bg-transparent"
                value={country}
                onChange={countryChange}
                type="text"
              >
                {countriesData}
              </select>
              {countryError ? (
                <span className="error-msg">Country required</span>
              ) : (
                ""
              )}
            </Col>
            <Col lg={6} className="mb-4">
              <Form.Label>
                City <span className="req">*</span>
              </Form.Label>
              <select
                id="inputcity"
                className="form-control border-0 border-bottom bg-transparent"
                value={city}
                onChange={cityHandler}
                type="text"
              >
                {cityData}
              </select>
              {cityError ? (
                <span className="error-msg">City required</span>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row className="mb-4">
            <Col>
              <Form.Label
                controlid="Business-Intro"
                label="Business Intro (less than 500 characters)"
              ></Form.Label>
              <Form.Control
                className="border-0 border-bottom bg-transparent"
                as="textarea"
                placeholder="Business Intro (less than 500 characters)"
                style={{ height: "100px", resize: "none" }}
                value={businessIntro}
                onChange={businessIntroHandler}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mb-4">
              <Form.Group controlid="formFile">
                <Form.Label>
                  Business Images(Picture) <span className="req">*</span>
                </Form.Label>
                <Form.Label className="file picture-file">
                  <Form.Control
                    className="form-control border-0 border-bottom bg-transparent"
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    encType="multipart/form-data"
                    onChange={imageOneHandler}
                    multiple={true}
                  />

                  <span className="bg-white file-custom"></span>
                  <span>{}</span>
                </Form.Label>
              </Form.Group>
              {imageOnePreview != null ? (
                imageOnePreview !== `${IMAGE_URL_BUSINESS}null` ? (
                  imageOnePreview != `${IMAGE_URL_BUSINESS}undefined` ? (
                    <>
                      <img
                        src={imageOnePreview}
                        alt="image"
                        className="img-thumbnail"
                        style={{ width: "195px", height: "150px" }}
                      />
                      <button
                        onClick={() => {
                          setImageOnePreview(`${IMAGE_URL_BUSINESS}undefined`);
                        }}
                      >
                        X
                      </button>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              {imageTwoPreview != null ? (
                imageTwoPreview !== `${IMAGE_URL_BUSINESS}null` ? (
                  imageTwoPreview != `${IMAGE_URL_BUSINESS}undefined` ? (
                    <>
                      <img
                        src={imageTwoPreview}
                        alt="image"
                        className="img-thumbnail"
                        style={{ width: "195px", height: "150px" }}
                      />
                      <button
                        onClick={() => {
                          setImageTwoPreview(`${IMAGE_URL_BUSINESS}undefined`);
                        }}
                      >
                        X
                      </button>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              {console.log(" k f : " + imageThreePreview)}
              {imageThreePreview != null ? (
                imageThreePreview !== `${IMAGE_URL_BUSINESS}null` ? (
                  imageThreePreview != `${IMAGE_URL_BUSINESS}undefined` ? (
                    <>
                      <img
                        src={imageThreePreview}
                        alt="image"
                        className="img-thumbnail"
                        style={{ width: "195px", height: "150px" }}
                      />
                      <button
                        onClick={() => {
                          setImageThreePreview(
                            `${IMAGE_URL_BUSINESS}undefined`
                          );
                        }}
                      >
                        X
                      </button>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              {imageFourPreview != null ? (
                imageFourPreview !== `${IMAGE_URL_BUSINESS}null` ? (
                  imageFourPreview != `${IMAGE_URL_BUSINESS}undefined` ? (
                    <>
                      <img
                        src={imageFourPreview}
                        alt="image"
                        className="img-thumbnail"
                        style={{ width: "195px", height: "150px" }}
                      />
                      <button
                        onClick={() => {
                          setImageFourPreview(`${IMAGE_URL_BUSINESS}undefined`);
                        }}
                      >
                        X
                      </button>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              {imageFivePreview != null ? (
                imageFivePreview !== `${IMAGE_URL_BUSINESS}null` ? (
                  imageFivePreview != `${IMAGE_URL_BUSINESS}undefined` ? (
                    <>
                      <img
                        src={imageFivePreview}
                        alt="image"
                        className="img-thumbnail"
                        style={{ width: "195px", height: "150px" }}
                      />

                      <button
                        onClick={() => {
                          setImageFivePreview(`${IMAGE_URL_BUSINESS}undefined`);
                        }}
                      >
                        X
                      </button>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )
              ) : (
                ""
              )}

              {imageOneError ? (
                <span className="error-msg">
                  At least one Business image required
                </span>
              ) : (
                ""
              )}
            </Col>
            <Col lg={6} className="mb-4">
              <Form.Group controlid="formFile">
                <Form.Label>
                  Business Profile(PDF/Picture) <span className="req"></span>
                </Form.Label>
                <Form.Label className="file pdf-file">
                  <Form.Control
                    className="form-control border-0 border-bottom bg-transparent"
                    type="file"
                    accept=".pdf, .doc, .docx, .png, .jpg, .jpeg"
                    encType="multipart/form-data"
                    onChange={businessProfileHandler}
                  />
                  <span className="bg-white file-custom"></span>
                  <span>{businessProfileName}</span>
                </Form.Label>
              </Form.Group>
              {businessProfilePreview ? (
                <a
                  className="pdf-btn"
                  href={
                    businessProfilePreview
                      ? `${IMAGE_URL_UPLOAD}business_profile/${businessProfilePreview}`
                      : ""
                  }
                  target="_blank"
                >
                  Business Profile
                </a>
              ) : (
                ""
              )}

              {businessProfilePreview ? (
                <button
                  onClick={() => {
                    setBusinessProfilePreview(undefined);
                  }}
                >
                  X
                </button>
              ) : (
                ""
              )}

              {businessProfileIsEmptyErr ? (
                <span className="error-msg">Business Profile is required</span>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <div className="float-end">
            <Modal show={submitLoader} onHide={loaderClose}>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </Modal>
            <Button
              className="btn-full-color"
              type="submit"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={submitSuccess}
        onHide={submitSuccessClose}
        className="SubmitPopup"
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="text-center py-5">
          <svg
            width="78"
            height="78"
            viewBox="0 0 78 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_113_322)">
              <path
                d="M42.2982 73.7798C61.5168 71.7083 75.4184 54.4594 73.3482 35.2533C71.278 16.0473 54.02 2.15707 34.8014 4.22862C15.5827 6.30017 1.68115 23.5491 3.75134 42.7551C5.82154 61.9611 23.0795 75.8514 42.2982 73.7798Z"
                fill="#9F7854"
              />
              <path
                d="M33.4835 57.1484L18.8401 42.1276L24.3222 36.7842L33.3144 46.0081L53.2186 24.3097L58.8613 29.4841L33.4835 57.1484Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_113_322">
                <rect
                  width="70"
                  height="70"
                  fill="white"
                  transform="translate(0 7.95245) rotate(-6.15208)"
                />
              </clipPath>
            </defs>
          </svg>
          <p className="pb-3 pt-3">
            Your details are successfully submitted and under review.
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default UpdateBusiness;
